 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~pages-buyer-buyer-module~pages-supplier-supplier-module":"default~pages-buyer-buyer-module~pages-supplier-supplier-module","common":"common","pages-buyer-buyer-module":"pages-buyer-buyer-module","pages-supplier-supplier-module":"pages-supplier-supplier-module","pages-public-public-module":"pages-public-public-module","buyer-dashboard-contracts-contracts-module":"buyer-dashboard-contracts-contracts-module","buyer-dashboard-offers-offers-module":"buyer-dashboard-offers-offers-module","buyer-dashboard-orders-orders-module":"buyer-dashboard-orders-orders-module","buyer-dashboard-overview-overview-module":"buyer-dashboard-overview-overview-module","buyer-dashboard-shop-shop-module":"buyer-dashboard-shop-shop-module","buyer-dashboard-buyer-products-buyer-products-module":"buyer-dashboard-buyer-products-buyer-products-module","default~buyer-dashboard-tenders-tenders-module~supplier-dashboard-tender-supplier-tender-supplier-module":"default~buyer-dashboard-tenders-tenders-module~supplier-dashboard-tender-supplier-tender-supplier-module","buyer-dashboard-tenders-tenders-module":"buyer-dashboard-tenders-tenders-module","products-supplier-products-supplier-module":"products-supplier-products-supplier-module","supplier-dashboard-contract-supplier-contract-supplier-module":"supplier-dashboard-contract-supplier-contract-supplier-module","supplier-dashboard-tender-supplier-tender-supplier-module":"supplier-dashboard-tender-supplier-tender-supplier-module","supplier-dashboard-analytics-analytics-module":"supplier-dashboard-analytics-analytics-module","supplier-dashboard-order-supplier-order-supplier-module":"supplier-dashboard-order-supplier-order-supplier-module","supplier-dashboard-overview-overview-module":"supplier-dashboard-overview-overview-module","supplier-supplier-dashboard-profile-settings-profile-settings-module":"supplier-supplier-dashboard-profile-settings-profile-settings-module","order-details-order-details-module":"order-details-order-details-module","supplier-dashboard-contract-supplier-contract-details-supplier-contract-details-supplier-module":"supplier-dashboard-contract-supplier-contract-details-supplier-contract-details-supplier-module","order-details-supplier-order-details-supplier-module":"order-details-supplier-order-details-supplier-module"}[chunkId]||chunkId) + "-es2015." + {"default~pages-buyer-buyer-module~pages-supplier-supplier-module":"6e8d96ad27509d2bcf1f","common":"b27bfc46a87dc2fe8335","pages-buyer-buyer-module":"938b2ef46d9d688098df","pages-supplier-supplier-module":"303ac910cea64a08d90c","pages-public-public-module":"9db5cb9da6d40b60d496","buyer-dashboard-contracts-contracts-module":"9ef13bcaa8391e32afc8","buyer-dashboard-offers-offers-module":"eae22607772678e432de","buyer-dashboard-orders-orders-module":"b1be599a78aded14b2c4","buyer-dashboard-overview-overview-module":"571d966644b052ee2484","buyer-dashboard-shop-shop-module":"83cb9224550663d3d789","buyer-dashboard-buyer-products-buyer-products-module":"fe8745ae9140f861568a","default~buyer-dashboard-tenders-tenders-module~supplier-dashboard-tender-supplier-tender-supplier-module":"40a563598be317d8526b","buyer-dashboard-tenders-tenders-module":"303adfe4b5ee70c39f15","products-supplier-products-supplier-module":"8bf138a390a65f32ff5f","supplier-dashboard-contract-supplier-contract-supplier-module":"291d0f87d0d1e843bdc6","supplier-dashboard-tender-supplier-tender-supplier-module":"94cbbd015d53d44c003b","supplier-dashboard-analytics-analytics-module":"bb16c2b37791e6822c4e","supplier-dashboard-order-supplier-order-supplier-module":"5b720bdf8c22740939ee","supplier-dashboard-overview-overview-module":"a058acaaf61150a55bcb","supplier-supplier-dashboard-profile-settings-profile-settings-module":"6937380d97e371f58ce4","order-details-order-details-module":"fb7623626b3f11f045c9","supplier-dashboard-contract-supplier-contract-details-supplier-contract-details-supplier-module":"58ce1ac44474061da3de","order-details-supplier-order-details-supplier-module":"b824bcc7625b3e8945b1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
